import Fitter from './fitter';
import {setOrFallbackValue} from './helper';
import FitterFee from './fitter_fee';
import FitterService from './fitter_service';
export default class FittingOption {
    constructor(props) {
        this.fs = ('' === setOrFallbackValue(props, 'fs', '')) ?
            {} : new Fitter(props.fs);
        this.fees = (null === setOrFallbackValue(props, 'fees', null)) ?
            [] : props.fees.map((fee) => {
                return new FitterFee(fee);
            });
        this.services = (null === setOrFallbackValue(props, 'services', null)) ?
            [] : props.services.map((service) => {
                return new FitterService(service);
            });
    }
}
